/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  const FormTemplate = require('./fuel-form/fuel-form.template.html');
  const TableTemplate = require('./fuel-table/fuel-table.template.html');

  $routeProvider
    .when('/sales/fuel/add', {
      templateUrl: FormTemplate,
      title: 'Tankbeleg eingeben',
    })
    .when('/sales/fuel/edit/:receiptId', {
      templateUrl: FormTemplate,
      title: 'Tankbeleg bearbeiten',
    })
    .when('/sales/fuel/table', {
      templateUrl: TableTemplate,
      title: 'Kraftstoffkosten',
    });
}
